import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { DocumentosProjeto } from '../../models/documentos-projeto.model';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';
import { DocumentosProjetoService } from '../../services/documentos-projeto.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';

@Component({
  selector: 'app-detalhe-documento-list',
  templateUrl: './detalhe-documento-list.component.html',
  styleUrls: ['./detalhe-documento-list.component.scss']
})
export class DetalheDocumentoListComponent extends BaseListComponent<DocumentosProjeto> implements OnInit, OnDestroy {

  @Input() isProjeto: boolean = true;
  @Input() idEntrega: number;
  @Input() idIndicador: number;
  @Input() idPgIndicador: number;
  @Input() idDoc: number;
  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  documentoList: DocumentosProjeto[];
  permission: any;

  constructor(
    private myService: DocumentosProjetoService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super();
  }

  ngOnInit() {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.initList();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

	initList() {
		this.myService.list(this.typeQueryParams()).then((res) => {
			this.documentoList = res['list'];
			this.permission = res['permission'];
			this.loaded();
		});
	}

	typeQueryParams() {
		let queryParams: any;
		if (this.isProjeto) {
			queryParams = { pf_id: this.idProjeto };
		} else {
			if (this.idEntrega) {
				queryParams = { prt_issue_id: this.idEntrega };
			} else if (this.idIndicador) {
				queryParams = { ind_id: this.idIndicador };
			} else if (this.idPgIndicador) {
				queryParams = { pg_ind_id: this.idPgIndicador };
			} else if (this.idDoc) {
				queryParams = { doc_id: this.idDoc };
			}
		}
		return queryParams;
	}

  novo() {
    if (this.idPgIndicador) {
      return ['/projetos', 'documentos', 'adicionar'];
	} else if (this.idDoc) {
	  return ['/projetos/tutoriais/adicionar'];
    } else {
      return ['/projetos', 'projeto', this.idProjeto, 'documentos', 'adicionar'];
    }
  }

  confirmExcluir(data: any) {
    this.alertConfirmation().subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(data);
      }
    });
  }

  excluir(data: any): void {
    this.loading();
    this.myService.delete(data.id).subscribe({
      next: (res) => {
        this.initList();
        this.msgSuccess();
      },
      error: (error) => {
        this.loaded();
      }
    });
  }

  updateClickHandler(data: any) {
    if (this.idPgIndicador) {
      return ['/projetos', 'documentos', data.id];
    } else if (this.idDoc) {
	  return ['/projetos/tutoriais', data.id];
    } else {
      return ['/projetos', 'projeto', this.idProjeto, 'documentos', data.id];
    }
  }

  download(data) {
    this.loading();
    this.addSub(
      this.myService.download(data.id).subscribe({
        next: (res) => {
          const contentDispositionHeader = res.headers.get('content-disposition');
          const fileName = contentDispositionHeader ? this.myService.extractFilename(contentDispositionHeader) : data?.name;
          const blob = new Blob([res.body], { type: 'application/octet-stream' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = fileName;
          link.click();
          window.URL.revokeObjectURL(url);
          this.loaded();
        },
        error: (error) => {
          let msg;
          if (error?.status == 404) {
            msg = "Arquivo não encontrado.";
          }
          this.msgError(msg ? msg : error?.error?.message);
          this.loaded();
        },
      })
    );
  }
}

